export const facultyData = {
  businessManagement: {
    departmentName: "Department of Business Management",
    faculty: [
      {
        id: "bm000",
        name: "Dr. C. Viswanatha Reddy",
        designation: "Professor and Head",
        department: "Business Management",
        email: "vsrits@gmail.com",
        mobile: "9848263463",
        photo: "/businessmanagement/prof vishwanath reddy.png",
        qualification: "M.Com., MBA, M.Phil., Ph.D.",
        specialization: "Finance, Accounting, Quantitatives, Predictive Analytics",
        profileLink: "/businessmanagement/C-VISWANATHA-REDDY.pdf"
      },
      {
        id: "bm001",
        name: "Dr. P. Nagaraju",
        designation: "Assistant Professor (MTS)",
        email: "drpnagaraju6@gmail.com",
        mobile: "9441193329",
        photo: "/businessmanagement/pnagarajuprofilephoto.JPG",
        qualification: "M.B.A., Ph.D.,UGC-NET",
        specialization: "Management Studies",
        profileLink: "/businessmanagement/mbanagarajusirupdatedprofile.pdf"
      },

      // {
      //   id: "bm002",
      //   name: "Dr. Rama Krishna Godha",
      //   designation: "Assistant Professor (C)",
      //   email: "drgrkrishna@gmail.com",
      //   mobile: "9951422499",
      //   photo: "/businessmanagement/ramakrishna.JPG",
      //   qualification: "M.B.A., Ph.D.",
      //   specialization: "Business Management",
      //   profileLink: "/businessmanagement/rama.pdf"
      // },

      {
        id: "bm003",
        name: "Dr. Pagadala Suchitra",
        designation: "Assistant Professor (C)",
        email: "svijay1820@gmail.com",
        mobile: "9848747421",
        photo: "/businessmanagement/sucharith.JPG",
        qualification: "M.B.A., Ph.D.,UGC-NET",
        specialization: "Human Resource Management (HRM) & Marketing Management (MM)",
        profileLink: "/businessmanagement/sucharith.pdf"
      },

      {
        id: "bm004",
        name: "Dr. G. Renuka",
        designation: "Assistant Professor (C)",
        email: "grenuka8@gmail.com",
        mobile: "9440546546",
        photo: "/businessmanagement/Renuka.JPG",
        qualification: "M.B.A., Ph.D.,APSET",
        specialization: "Management Studies",
        profileLink: "/businessmanagement/renuka.pdf"
      },

      {
        id: "bm005",
        name: "Dr. Gunda Surendra",
        designation: "Assistant Professor (C)",
        email: "surendragunda@gmail.com",
        mobile: "9440717755",
        photo: "/businessmanagement/surendra.JPG",
        qualification: "M.B.A., Ph.D.,APSET",
        specialization: "Business Management",
        profileLink: "/businessmanagement/gunda.pdf"
      }
    ]

  },

  commerce: {
    departmentName: "Department of Commerce",
    faculty: [
      {
        name: "Dr. N. Moses",
        designation: "Co-ordinator & Assistant Professor (C)",
        email: "drmosesknl@gmail.com",
        mobile: "9885499307",
        photo: "/commerce/moses.JPG",
        profileLink: "/commerce/moses.pdf"
      },
      {
        name: "Dr. V.V.L. Leelakumari",
        designation: "Assistant Professor (C)",
        email: "leelakotika@gmail.com",
        mobile: "9885492845",
        photo: "/commerce/leelakumari.JPG",
        profileLink: "/commerce/leela.pdf"
      },
      {
        name: "Dr. R. Bharathi",
        designation: "Teaching Assistant",
        email: "bharathi@gmail.com",
        mobile: "9441657691",
        photo: "/commerce/bharathi.JPG",
        profileLink: "/commerce/barathi.pdf"
      },
      {
        name: "Dr. M. Yugandharudu",
        designation: "Assistant Professor (C)",
        email: "m.yugandhar12@gmail.com",
        mobile: "8374348953",
        photo: "/commerce/yugandarudu.png",
        profileLink: "/commerce/yugandarudu.pdf"
      }
    ]
  },

  economics: {
    departmentName: "Department of Economics",
    faculty: [
      {
        id: "eco001",
        name: "Dr. N. T. K. Naik",
        designation: "Professor & Head",
        department: "Economics",
        university: "Rayalaseema University, Kurnool",
        email: "drntknaik@gmail.com",
        mobile: "9440861023",
        photo: "/economics/naik.JPG",
        qualification: "M.A. Economics, Ph.D.",
        specialization: "Agriculture economics, Indian economic policy",
        message: `Welcome to the Department of Economics at Rayalaseema University. 
The department is committed to providing high-quality education and research 
in economics with a strong focus on analytical thinking, policy understanding, 
and socio-economic development.

Our academic programmes are designed to equip students with a sound foundation 
in economic theory, quantitative methods, and applied economics, enabling them 
to critically analyze real-world economic issues at regional, national, and 
global levels. The department encourages research, innovation, and interdisciplinary 
learning to address contemporary economic challenges.

We strive to nurture socially responsible graduates who can contribute effectively 
to public policy formulation, research institutions, academia, civil services, 
and the corporate sector. With a dedicated faculty and a supportive academic 
environment, the Department of Economics continuously works towards academic 
excellence and meaningful societal impact.`,

        profileLink: "/economics/NTK-NAIK.pdf"
      },
      {
        id: "eco002",
        name: "Dr. N. Sreedhar",
        designation: "Co-ordinator & Assistant Professor (C)",
        department: "Economics",
        university: "Rayalaseema University, Kurnool",

        email: "sree7473@gmail.com",
        mobile: "8897977473",
        photo: "/economics/nsreedhar.JPG",
        profileLink: "/economics/sreedhar.pdf",

        dateOfBirth: "01-08-1971",
        dateOfJoining: "August 2001",

        qualification: "B.A., M.A., Ph.D.",
        specialization: "Developmental Economics",
      }
    ]
  },

  english: {
    departmentName: "Department of English",
    faculty: [
      {
        name: "Prof. Mary Elizabeth",
        designation: "Professor & Head",
        email: "mary.elizabeth@ruk.ac.in",
        mobile: "+91 98765 43223",
        photo: "/english/mary-elizabeth.JPG",
        profileLink: "/english/MARY-ELIZABETH.pdf"
      },
      {
        name: "Dr. David Johnson",
        designation: "Associate Professor",
        email: "david.johnson@ruk.ac.in",
        mobile: "+91 98765 43224",
        photo: "/english/david-johnson.JPG",
        profileLink: "/english/DAVID-JOHNSON.pdf"
      },
      {
        name: "Dr. Anjali Gupta",
        designation: "Assistant Professor",
        email: "anjali.gupta@ruk.ac.in",
        mobile: "+91 98765 43225",
        photo: "/english/anjali-gupta.JPG",
        profileLink: "/english/ANJALI-GUPTA.pdf"
      },
      {
        name: "Dr. Ravi Shankar",
        designation: "Assistant Professor",
        email: "ravi.shankar@ruk.ac.in",
        mobile: "+91 98765 43226",
        photo: "/english/ravi-shankar.JPG",
        profileLink: "/english/RAVI-SHANKAR.pdf"
      }
    ]
  },

  telugu: {
    departmentName: "Department of Telugu",
    faculty: [
      {
        id: "tel001",
        name: "Dr. N. Narasimhulu",
        designation: "Professor & Head",
        email: "drnnarasimhuluknl@gmail.com",
        mobile: "9182034667",
        photo: "/telugu/Narasimhulu.JPG",
        profileLink: "/telugu/NARASIMHULU.pdf",
        qualification: "M.A (Telugu), M.Phil, Ph.D",
        specialization: "Folk  Literature ",
      },
      {
        id: "tel002",
        name: "Dr. P. Sreenivasulu",
        designation: "Assistant Professor (C)",
        email: "srinivasulupurohitam3706@gmail.com",
        mobile: "9440035438",
        photo: "/telugu/sreenivasulu.JPG",
        profileLink: "/telugu/SREENIVASULU.pdf",
        qualification: "M.A (Telugu),  Ph.D",
        specialization: "Folk and old Literature and Sanskrit",
      },
      {
        id: "tel003",
        name: "Dr. V. Ravi Sankar",
        designation: "Assistant Professor (C)",
        email: "dr.v.ravisankar@gmail.com",
        mobile: "9440225207",
        photo: "/telugu/ravishankart.JPG",
        profileLink: "/telugu/RAVI.pdf",
        qualification: "M.A (Telugu),  Ph.D",
        specialization: "Classical Literature, Grammar & Journalism ",
      },
      {
        id: "tel004",
        name: "Dr. Anjaneyulu",
        designation: "Assistant Professor (C)",
        email: "premsantosh2014@gmail.com",
        mobile: "9494736351",
        photo: "/telugu/anjaneyulut.JPG",
        profileLink: "/telugu/anjaneyalusir.pdf",
        qualification: "M.A (Telugu),  Ph.D",
        specialization: "Modern Literature",
      },
      {
        id: "tel005",
        name: "Dr. Aruna Gandam",
        designation: "Assistant Professor (C)",
        email: "arunagandham728@gmail.com",
        mobile: "9701786222",
        photo: "/telugu/Aruna_Telugu.JPG",
        profileLink: "/telugu/ARUNA-GANDAM.pdf",
        qualification: "M.A (Telugu), M.Phil, Ph.D,APSET,UGC-NET",
        specialization: "Modern Poetry",
      },
      {
        id:'tel006',
        name: "Dr. Medikurthi Obulesu",
        designation: "Assistant Professor (C)",
        email: "medikurthiobulesu@gmail.com",
        mobile: "8142177887",
        photo: "/telugu/obulesu.png",
        profileLink: "/telugu/MEDIKURTHI.pdf",
        qualification: "M.A (Telugu), M.Phil, Ph.D, UGC-NET,APSET",
        specialization: "Modern Literature",
      }
    ]
  },

  computerScience: {
    departmentName: "Department of Computer Science",
    faculty: [
      {
        id: "cs002",
        name: "Dr. K. Nagamani ",
        designation: "Assistant Professor",
        email: "kancharlamani@gmail.com",
        mobile: "9397088071",
        qualification: "M.Sc., M.Tech, M.Phil., Ph.D.",
        specialization: 'web technologies, data science',
        photo: "/computerscience/nagamani.jpg",
        profileLink: "/computerscience/KANCHERLA.pdf"
      },
      {
        id: "cs001",
        name: "Dr. G. Ravi Kumar ",
        designation: "Assistant Professor & Coordinator",
        qualification: "M.C.A.,  M.Phil., Ph.D.,APSET",
        specialization: "Artificial Intelligence, Machine Learning, Big Data Analytics.",
        email: "grkondaravi@gmail.com",
        mobile: "8555919531",
        photo: "/computerscience/ravi.JPG",
        profileLink: "/computerscience/GORMANUKONDA.pdf"
      },
      
      {
        id: "cs003",
        name: "Dr. M. Rajeswari",
        designation: "Assistant Professor",
        email: "rajeswarirucs@gmail.com",
        mobile: "9030160281",
        qualification: "M.Sc.,  Ph.D.",
        specialization: 'database management systems, computer networks',
        photo: "/computerscience/rajeshwari.JPG",
        profileLink: "/computerscience/RAJESWARI.pdf"
      },
      {
        id: "cs004",
        name: "Dr. Manda Vijay Kumar Naidu M.C.A, PhD, ",
        designation: "Assistant Professor (C)",
        specialization: "Generative Artificial Intelligence, Web Technologies.",
        email: "mandavijaykumar40@gmail.com",
        mobile: "8639780283",
        qualification: "M.C.A, PhD, APSET,UGC-NET",
        photo: "/computerscience/mandavijaykumarnaidu.JPG",
        profileLink: "/computerscience/MANDA.pdf"
      }
    ]
  },

  mathematics: {
    departmentName: "Department of Mathematics",
    faculty: [
      {
        id: "math001",
        name: "Prof. Venkata Sundaranand Putcha, M.Sc., Ph.D.",
        designation: "Professor & Head",
        email: "anand_putcha@yahoo.com",
        mobile: "9848226855",
        photo: "/person/putcha.jpg",
        profileLink: "/mathematics/VENKATA-SUNDARANAND-PUTCHA.pdf"
      },
      {
        id: "math002",
        name: "Dr. M. Veera Krishna ",
        designation: "Assistant Professor (C)",
        email: "veerakrishna_maths@yahoo.com",
        mobile: "9849650682",
        photo: "/mathematics/veerakrishna.JPG",
        profileLink: "/mathematics/M-VEERA-KRISHNA.pdf"
      },
      {
        id: "math003",
        name: "Dr. S.V. Suneetha M.Sc., MPhil., PhD.",
        designation: "Assistant Professor (C)",
        email: "sunithaknl17@gmail.com",
        mobile: "9866945663",
        photo: "/mathematics/sunnetha.JPG",
        profileLink: "/mathematics/SV-SUNEETHA.pdf"
      },
      {
        id: "math004",
        name: "Dr. U. Nagi Reddy M.Sc., M.Phil, Ph.D.",
        designation: "Assistant Professor (C)",
        email: "nagireddyppr@gmail.com",
        mobile: "8106415164",
        photo: "/mathematics/Nagireddy.JPEG",
        profileLink: "/mathematics/U-NAGI-REDDY.pdf"
      }
    ]
  },

  physics: {
    departmentName: "Department of Physics",
    faculty: [
      {
        name: "Dr. C. V. Krishna Reddy M.Sc., M.Phil., Ph.D.",
        designation: "Professor and Head",
        email: "reddycvk02@yahoo.co.in",
        mobile: "9989642920",
        photo: "/physics/cvkredd.JPG",
        profileLink: "/physics/CV-KRISHNA-REDDY.pdf",
        specialization: "Solid State Spectroscopy  ",
      },
      {
        name: "Dr. G. K. Siva Sankara Yadav M.Sc., M.Phil., Ph.D.",
        designation: "Assistant Professor (C)",
        email: "gkssyadav@gmail.com",
        mobile: "9441510086",
        photo: "/physics/yadav.JPG",
        profileLink: "/physics/GK-SIVA-SANKARA-YADAV.pdf",
        specialization: "Materials Science ",
      },
      {
        name: "Dr. E. Rajasekhar M.Sc., Ph.D.",
        designation: "Assistant Professor (C)",
        email: "physics.rajasekhar@gmail.com",
        mobile: "9985075726",
        photo: "/physics/rajasekhar.JPG",
        profileLink: "/physics/RAJASEKHAR.pdf",
        specialization: "APPLIED PHYSICS /  ELECTRONICS ",
      }
    ]
  },

  chemistry: {
    departmentName: "Department of Chemistry",
    faculty: [
      {
        name: "Prof. M. E. Rani",
        designation: "Professor & Head",
        email: "drmerani@gmail.com",
        mobile: "9705236392",
        photo: "/chemistry/ProfRani.jpeg",
        profileLink: "/chemistry/M-E-RANI.pdf"
      }
    ]
  },

  botany: {
    departmentName: "Department of Botany",
    faculty: [
      {
        name: "Dr. Bharath Kumar Ravuru",
        designation: "Professor & Head",
        email: "drbharathravuru@gmail.com",
        mobile: "8500722075",
        photo: "/botany/obulesu.png",
        profileLink: "/botany/bharath.pdf"
      },
      {
        name: "Dr. G. Sri Ranganayakulu",
        designation: "Assistant Professor (MTS)",
        email: "gsranganaayakulu@gmail.com",
        mobile: "9989239242",
        photo: "/botany/ranga.JPG",
        profileLink: "/botany/ranga.pdf"
      },
      {
        name: "Dr. K. Venkata Ratnam",
        designation: "Assistant Professor (C)",
        email: "drvenkatapkd@gmail.com",
        mobile: "8008497926",
        photo: "/botany/venkataramanabotony.png",
        profileLink: "/botany/VENKATA.pdf"
      },
      {
        name: "Dr. Kavitha Bommana",
        designation: "Assistant Professor (C)",
        email: "kavithab15@Gmail.com",
        mobile: "9290755720",
        photo: "/botany/kavitha.JPG",
        profileLink: "/botany/KAVITHA.pdf"
      }
    ]
  },

  zoology: {
    departmentName: "Department of Zoology",
    faculty: [
      {
        name: "Dr. M. Nagabhushan Reddy M.Sc., M.Phil., Ph.D.",
        designation: "Assistant Professor (MTS)",
        email: "mnabhushr@yahoo.com",
        mobile: "8500981295",
        photo: "/zoology/Drnagabushion.jpeg",
        profileLink: "/zoology/NAGABHUSHAN.pdf"
      },
      {
        name: "Dr. M. Venkata Chandrudu M.Sc., Ph.D.",
        designation: "Assistant Professor (MTS)",
        email: "chandramidde4@gmail.com",
        mobile: "9963735227",
        photo: "/zoology/chandra_profile1.png",
        profileLink: "/zoology/chandra-profile.pdf"
      },
      {
        name: "Dr. Bandela Vijayudu M.Sc., Ph.D..",
        designation: "Assistant Professor (C)",
        email: "bandelavijay5@gmail.com",
        mobile: "8374742791",
        photo: "/zoology/bandela.png",
        profileLink: "/zoology/BANDELA.pdf"
      },
      {
        name: "Dr. R.Sreedhar M.Sc., Ph.D.",
        designation: "Assistant Professor (C)",
        email: "rayasamsreedhar@gmail.com",
        mobile: "9492405600",
        photo: "/zoology/sreedaer.png",
        profileLink: "/zoology/sreedaer.pdf"
      }

    ]
  },

  electronics: {
    departmentName: "Department of Electronics & Communication Engineering",
    faculty: [
      {
        name: "Prof. Narasimha Rao",
        designation: "Professor & Head",
        email: "narasimha.rao@ruk.ac.in",
        mobile: "+91 98765 43250",
        photo: "/electronics/narasimha-rao.JPG",
        profileLink: "/electronics/NARASIMHA-RAO.pdf"
      },
      {
        name: "Dr. Usha Rani",
        designation: "Associate Professor",
        email: "usha.rani@ruk.ac.in",
        mobile: "+91 98765 43251",
        photo: "/electronics/usha-rani.JPG",
        profileLink: "/electronics/USHA-RANI.pdf"
      },
      {
        name: "Dr. Satish Kumar",
        designation: "Assistant Professor",
        email: "satish.kumar@ruk.ac.in",
        mobile: "+91 98765 43252",
        photo: "/electronics/satish-kumar.JPG",
        profileLink: "/electronics/SATISH-KUMAR.pdf"
      }
    ]
  },

  mechanical: {
    departmentName: "Department of Mechanical Engineering",
    faculty: [
      {
        name: "Prof. Ravi Kiran",
        designation: "Professor & Head",
        email: "ravi.kiran@ruk.ac.in",
        mobile: "+91 98765 43253",
        photo: "/mechanical/ravi-kiran.JPG",
        profileLink: "/mechanical/RAVI-KIRAN.pdf"
      },
      {
        name: "Dr. Srinivas Reddy",
        designation: "Associate Professor",
        email: "srinivas.reddy@ruk.ac.in",
        mobile: "+91 98765 43254",
        photo: "/mechanical/srinivas-reddy.JPG",
        profileLink: "/mechanical/SRINIVAS-REDDY.pdf"
      },
      {
        name: "Dr. Venkata Rao",
        designation: "Assistant Professor",
        email: "venkata.rao@ruk.ac.in",
        mobile: "+91 98765 43255",
        photo: "/mechanical/venkata-rao.JPG",
        profileLink: "/mechanical/VENKATA-RAO.pdf"
      }
    ]
  },

  civil: {
    departmentName: "Department of Civil Engineering",
    faculty: [
      {
        name: "Prof. Gopal Krishna",
        designation: "Professor & Head",
        email: "gopal.krishna@ruk.ac.in",
        mobile: "+91 98765 43256",
        photo: "/civil/gopal-krishna.JPG",
        profileLink: "/civil/GOPAL-KRISHNA.pdf"
      },
      {
        name: "Dr. Bharathi Devi",
        designation: "Associate Professor",
        email: "bharathi.devi@ruk.ac.in",
        mobile: "+91 98765 43257",
        photo: "/civil/bharathi-devi.JPG",
        profileLink: "/civil/BHARATHI-DEVI.pdf"
      },
      {
        name: "Dr. Ramachandra",
        designation: "Assistant Professor",
        email: "ramachandra@ruk.ac.in",
        mobile: "+91 98765 43258",
        photo: "/civil/ramachandra.JPG",
        profileLink: "/civil/RAMACHANDRA.pdf"
      }
    ]
  },

  computerScienceEngg: {
    departmentName: "Department of Computer Science & Engineering",
    faculty: [
      {
        name: "Prof. Raghava Rao",
        designation: "Professor & Head",
        email: "raghava.rao@ruk.ac.in",
        mobile: "+91 98765 43259",
        photo: "/computerscienceengg/raghava-rao.JPG",
        profileLink: "/computerscienceengg/RAGHAVA-RAO.pdf"
      },
      {
        name: "Dr. Sowmya Devi",
        designation: "Associate Professor",
        email: "sowmya.devi@ruk.ac.in",
        mobile: "+91 98765 43260",
        photo: "/computerscienceengg/sowmya-devi.JPG",
        profileLink: "/computerscienceengg/SOWMYA-DEVI.pdf"
      },
      {
        name: "Dr. Kiran Kumar",
        designation: "Assistant Professor",
        email: "kiran.kumar@ruk.ac.in",
        mobile: "+91 98765 43261",
        photo: "/computerscienceengg/kiran-kumar.JPG",
        profileLink: "/computerscienceengg/KIRAN-KUMAR.pdf"
      }
    ]
  },

  artificialIntelligence: {
    departmentName: "Department of Artificial Intelligence & Data Science",
    faculty: [
      {
        name: "Prof. Mahesh Kumar",
        designation: "Professor & Head",
        email: "mahesh.kumar@ruk.ac.in",
        mobile: "+91 98765 43262",
        photo: "/artificialintelligence/mahesh-kumar.JPG",
        profileLink: "/artificialintelligence/MAHESH-KUMAR.pdf"
      },
      {
        name: "Dr. Anitha Rani",
        designation: "Associate Professor",
        email: "anitha.rani@ruk.ac.in",
        mobile: "+91 98765 43263",
        photo: "/artificialintelligence/anitha-rani.JPG",
        profileLink: "/artificialintelligence/ANITHA-RANI.pdf"
      },
      {
        name: "Dr. Prasad Kumar",
        designation: "Assistant Professor",
        email: "prasad.kumar@ruk.ac.in",
        mobile: "+91 98765 43264",
        photo: "/artificialintelligence/prasad-kumar.JPG",
        profileLink: "/artificialintelligence/PRASAD-KUMAR.pdf"
      }
    ]
  },

  biotechnology: {
    departmentName: "Department of Biotechnology",
    faculty: [
      {
        name: "Prof. Malathi Devi",
        designation: "Professor & Head",
        email: "malathi.devi@ruk.ac.in",
        mobile: "+91 98765 43265",
        photo: "/biotechnology/malathi-devi.JPG",
        profileLink: "/biotechnology/MALATHI-DEVI.pdf"
      },
      {
        name: "Dr. Raghu Ram",
        designation: "Associate Professor",
        email: "raghu.ram@ruk.ac.in",
        mobile: "+91 98765 43266",
        photo: "/biotechnology/raghu-ram.JPG",
        profileLink: "/biotechnology/RAGHU-RAM.pdf"
      },
      {
        name: "Dr. Swathi Kumari",
        designation: "Assistant Professor",
        email: "swathi.kumari@ruk.ac.in",
        mobile: "+91 98765 43267",
        photo: "/biotechnology/swathi-kumari.JPG",
        profileLink: "/biotechnology/SWATHI-KUMARI.pdf"
      }
    ]
  },

  biochemistry: {
    departmentName: "Department of Biochemistry",
    faculty: [
      {
        name: "Prof. Sridhar Reddy",
        designation: "Professor & Head",
        email: "sridhar.reddy@ruk.ac.in",
        mobile: "+91 98765 43268",
        photo: "/biochemistry/sridhar-reddy.JPG",
        profileLink: "/biochemistry/SRIDHAR-REDDY.pdf"
      },
      {
        name: "Dr. Pushpa Latha",
        designation: "Associate Professor",
        email: "pushpa.latha@ruk.ac.in",
        mobile: "+91 98765 43269",
        photo: "/biochemistry/pushpa-latha.JPG",
        profileLink: "/biochemistry/PUSHPA-LATHA.pdf"
      },
      {
        name: "Dr. Harish Kumar",
        designation: "Assistant Professor",
        email: "harish.kumar@ruk.ac.in",
        mobile: "+91 98765 43270",
        photo: "/biochemistry/harish-kumar.JPG",
        profileLink: "/biochemistry/HARISH-KUMAR.pdf"
      }
    ]
  },

  statistics: {
    departmentName: "Department of Statistics",
    faculty: [
      {
        id: "stat001",
        name: "Dr. Y. Raghunatha Reddy ",
        designation: "COORDINATOR, Assistant Professor (C)",
        email: "drraghuy@gmail.com",
        mobile: "+91 89858 58282",
        photo: "/statistics/Ragu.JPG",
        qualification: "M.Sc, Ph.D, MBA",
        profileLink: "/statistics/yrr.pdf",
        specialization: "Relibility, Optimization Techniques ",
      },
      {
        id: "stat002",
        name: "Dr. Bandaru Sainath",
        designation: "Assistant Professor (C)",
        email: "bsainathphd@gmail.com",
        mobile: "+91 9908112071",
        photo: "/statistics/Sainanth.png",
        qualification: "M.Sc, Ph.D",
        profileLink: "/statistics/sainathpdf",
        specialization: "Statistical Quality Control ",
      }
    ]
  },

  humanities: {
    departmentName: "Department of Humanities & Social Sciences",
    faculty: [
      {
        name: "Prof. Vijay Kumar",
        designation: "Professor & Head",
        email: "vijay.kumar@ruk.ac.in",
        mobile: "+91 98765 43274",
        photo: "/humanities/vijay-kumar.JPG",
        profileLink: "/humanities/VIJAY-KUMAR.pdf"
      },
      {
        name: "Dr. Gayatri Devi",
        designation: "Associate Professor",
        email: "gayatri.devi@ruk.ac.in",
        mobile: "+91 98765 43275",
        photo: "/humanities/gayatri-devi.JPG",
        profileLink: "/humanities/GAYATRI-DEVI.pdf"
      },
      {
        name: "Dr. Shankar Rao",
        designation: "Assistant Professor",
        email: "shankar.rao@ruk.ac.in",
        mobile: "+91 98765 43276",
        photo: "/humanities/shankar-rao.JPG",
        profileLink: "/humanities/SHANKAR-RAO.pdf"
      }
    ]
  }
};